// extracted by mini-css-extract-plugin
module.exports = {"aboutContent":"styles_aboutContent__5HdRH","headline":"styles_headline__DbQkk"};